module.exports = __webpack_public_path__ + "static/media/filter.8f63127f.svg";